import React, { useEffect, useState, createRef } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import {
  loadData,
  updateData,
  updateCellValue,
  search,
} from "ka-table/actionCreators";
import { SortingMode, PagingPosition } from "ka-table/enums";
import stockService from "../services/flstock-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Modal } from "react-responsive-modal";
import { Multiselect } from "multiselect-react-dropdown";
import jsPDF from "jspdf";
import "jspdf-autotable";
const tablePropsInit = {
  columns: [
    { key: "drg_name", title: "Drug", width: 220 },
    { key: "pack", title: "Pack", width: 140 },
    { key: "description", title: "Description", width: 200 },
    { key: "qty_limit", title: "Limit", width: 120 },
    { key: "category", title: "Category", width: 180 },
    { key: "last_order_date", title: "Last Order Date", width: 150 },
    { key: "parent", title: "Parent", width: 100 },
    { key: "Actions", title: "Actions", width: 100 },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInit1 = {
  columns: [{ key: "drg_name", title: "Drug" }, { key: "vendor_item", title: "Vendor Item" }, {key:"pack",title:"Pack"}, { key: "ndc", title: "NDC" },{ key: "Actions",title: "Add" }],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const FLStockOrderForm = () => {
  const [loading, setLoading] = useState(false);
  const [showDrugList, setShowDrugList] = useState(false);
  const [parentsList, setParentList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [facList, setFacList] = useState([]);
  const [selectedParent, setSelectedParent] = useState("");
  const [selectedFac, setSelectedFac] = useState(0);
  const [edituserOpen, setEditUserOpen] = useState(false);
  const onCloseUserModal = () => setEditUserOpen(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [drugToDelete, setDrugToDelete] = useState(null);
  const onDeleteCloseModal = () => {
    setDeleteOpen(false);
    setDrugToDelete(null);
  };
  const [doctorList, setDoctorList] = useState();
  const [selectedDoc1, setselectedDoc1] = useState([]);
  const [selectedDoc2, setselectedDoc2] = useState([]);
  const [qtyValues, setQtyValues] = useState({});
  const [qtyErrors, setQtyErrors] = useState({});
  const [descValues, setDescValues] = useState({});
  const { register, setValue } = useForm({});
  const multiselectRef = createRef();
  const multiselectRef1 = createRef();
  const deleteDrug = (drgId) => {
    setDrugToDelete(drgId);
    setDeleteOpen(true);
  };
  const confirmDeleteDrug = async () => {
    setDeleteOpen(false);
    setLoading(true);
    try {
      await stockService.deleteDrg(drugToDelete);
      const { hide } = cogoToast.success("Drug deleted Successfully", {
        hideAfter: 15,
        onClick: () => { hide(); },
      });
      getExistingDrugs(selectedParent, selectedFac);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while deleting drug details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => { hide(); },
        }
      );
    }
    setLoading(false);
    setDrugToDelete(null);
  };
  async function assignDoctor(actnType, docType) {
    try {
      let doc1Value = multiselectRef.current.getSelectedItems();
      let doc2Value = multiselectRef1.current.getSelectedItems();
      if (selectedFac > 0) {
        let params = {
          parent: selectedParent,
          fac_id: selectedFac,
        };
        let msg = "";
        if (actnType) {
          if (docType === "doc1") {
            params.doc_id = doc1Value[0].id;
          }
          if (docType === "doc2") {
            params.doc_id_2 = doc2Value[0].id;
          }
          msg = "Doctor Assigned Successfully";
        } else {
          if (docType === "doc1") {
            params.doc_id = 0;
          }
          if (docType === "doc2") {
            params.doc_id_2 = 0;
          }
          msg = "Doctor Unassigned Successfully";
        }
        await stockService.assignDr(params);
        const { hide } = cogoToast.success(msg, {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      } else {
        const { hide } = cogoToast.error("Please Select Facility.", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    } catch (e) {}
  }
  const CustomCell = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div>
        <span className="inline-block">
          <img
            src="./img/active.svg"
            className="mt-1 w-4 h-4"
            alt="Remove"
            title="Remove"
            onClick={(e) => {
              deleteDrug(rowData.id);
            }}
          />
        </span>
      </div>
    );
  };
  const CustomCell2 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div>
        <span className="inline-block">
          {rowData.drg_name}
          {rowData.strength ? "-" + rowData.strength : ""}
          {rowData.dos_id ? "-" + rowData.dos_id : ""}
        </span>
      </div>
    );
  };
  const CustomVendorItemCell = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block">{rowData.vendor_item ?? ""}</span>
      </div>
    );
  };
  const CustomNdcCell = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block">{rowData.ndc ?? ""}</span>
      </div>
    );
  };
  const CustomCellQnty = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div className="grid w-full">
        <span className="inline-block">
          <input
            type="number"
            min="1"
            autoComplete="off"
            id={"qty_limit" + rowData.id}
            name="qty_limit"
            defaultValue={rowData.qty_limit ?? ""}
            placeholder="Quantity Limit"
            onBlur={async (e) => {
              const inputValue = e.currentTarget.value;
              const val = Number(inputValue);
              dispatch(updateCellValue(rowKeyValue, column.key, inputValue));
              if (!inputValue || val <= 0) {
                setQtyErrors((prev) => ({
                  ...prev,
                  [rowData.id]: "Quantity must be at least 1",
                }));
              } else {
                setQtyErrors((prev) => {
                  const next = { ...prev };
                  delete next[rowData.id];
                  return next;
                });
                setQtyValues((prev) => ({ ...prev, [rowData.id]: inputValue }));
                try {
                  setLoading(true);
                  await stockService.editDrg({ id: rowData.id, qty_limit: val });
                  setLoading(false);
                } catch (err) {
                  const { hide } = cogoToast.error(
                    "Error while saving quantity. Please try after sometime.",
                    { hideAfter: 15, onClick: () => { hide(); } }
                  );
                  setLoading(false);
                }
              }
            }}
            className="border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
          />
          {qtyErrors[rowData.id] && (
            <span className="text-hlred text-xs mt-1 block">
              {qtyErrors[rowData.id]}
            </span>
          )}
        </span>
      </div>
    );
  };
  const CustomCellDescription = ({ rowData }) => (
    <div className="grid w-full">
      <input
        type="text"
        maxLength={500}
        autoComplete="off"
        id={"desc" + rowData.id}
        name="description"
        defaultValue={descValues[rowData.id] ?? (rowData.description ?? "")}
        placeholder="Description"
        onBlur={async (e) => {
          const val = e.currentTarget.value;
          setDescValues((prev) => ({ ...prev, [rowData.id]: val }));
          try {
            setLoading(true);
            await stockService.editDrg({ id: rowData.id, description: val });
          } catch (err) {
            const { hide } = cogoToast.error(
              "Error saving description. Please try after sometime.",
              { hideAfter: 15, onClick: () => { hide(); } }
            );
          } finally {
            setLoading(false);
          }
        }}
        className="border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
      />
    </div>
  );
  const CustomCellCategory = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div className="grid w-full">
        <select
          id={"cat" + rowData.id}
          name="category"
          defaultValue={rowData.category ?? ""}
          onChange={async (e) => {
            const val = e.currentTarget.value;
            dispatch(updateCellValue(rowKeyValue, column.key, val));
            try {
              setLoading(true);
              await stockService.editDrg({
                id: rowData.id,
                category: val || null,
              });
            } catch (err) {
              const { hide } = cogoToast.error(
                "Error while saving category. Please try after sometime.",
                { hideAfter: 15, onClick: () => { hide(); } }
              );
            } finally {
              setLoading(false);
            }
          }}
          className="border focus:outline-none focus:none h-10 rounded-md pl-2 text-sm font-normal w-full"
        >
          <option value="">Select Category</option>
          {categoryList
            ? categoryList.map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))
            : null}
        </select>
      </div>
    );
  };
  const CustomCell5 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div>
        <span className="inline-block">
          {rowData.fac_id===0 ? "Yes" : "No"}
        </span>
      </div>
    );
  };

  const addDrug = async (
    drgId,
    parentId,
    facId,
    drg_name,
    dos_id,
    strength,
    pack
  ) => {
    let userDet = {
      parent: parentId,
      fac_id: facId,
      drg_id: drgId,
      drg_name: drg_name,
      dos_id: dos_id,
      strength: strength,
      pack: pack,
    };
    setLoading(true);
    try {
      let resp = await stockService.addDrg(userDet);
      if (resp.code === 200 || resp.code === 204) {
        const { hide } = cogoToast.success("Drug Added Successfully", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        getExistingDrugs(selectedParent, selectedFac);
      } else if (resp.code === 400) {
        const { hide } = cogoToast.error(
          "Error while saving drug details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        getExistingDrugs(selectedParent, selectedFac);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while saving drug details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
    setLoading(false);
  };
  const CustomCell1 = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block">
          <img
            src="./img/addIcon.svg"
            className="mt-1 w-4 h-4"
            alt="Add"
            title="Add"
            onClick={(e) => {
              addDrug(
                rowData.id,
                selectedParent,
                selectedFac,
                rowData.drg_name,
                rowData.dos_id,
                rowData.strength,
                rowData.pack
              );
            }}
          />
        </span>
      </div>
    );
  };
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [tableProps1, changeTableProps1] = useState(tablePropsInit1);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
  };
  const dispatch1 = async (action) => {
    changeTableProps1((prevState) => kaReducer(prevState, action));
  };
  const getParents = async () => {
    try {
      setLoading(true);
      let resp = await stockService.getParent();
      if (resp) {
        setParentList(resp);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  // Load the category options served by the backend. Adjust the method name
  // (getCategories) if your service exposes it differently.
  const getCategories = async () => {
    try {
      let resp = await stockService.getCategories();
      if (resp) {
        setCategoryList(resp);
      }
    } catch (e) {}
  };

  async function getFacilities(parentId) {
    if (parentId !== "") {
      try {
        setLoading(true);
        let resp = await stockService.getFacByParent(parentId);
        resp.sort((a, b) => a.name.localeCompare(b.name));
        //resp.sort((d1, d2) => new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime());
        setFacList(resp);
        setSelectedParent(parentId);
        setValue("facility", 0);
        setselectedDoc1([]);
        setselectedDoc2([]);
        getExistingDrugs(parentId, 0);
        setLoading(false);
      } catch (e) {
        setselectedDoc1([]);
        setselectedDoc2([]);
        const { hide } = cogoToast.error(
          "Error while getting facilities details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  }
  async function getExistingDrugs(parentId, facility) {
    try {
      setLoading(true);
      let result = await stockService.getMasterDrugList(parentId, facility);
      let resp = result.drugs.sort((a, b) => b.id - a.id);
      dispatch(updateData(resp));
      setSelectedFac(facility);
      if (resp.length > 0) {
        setShowDrugList(true);
      }
      setselectedDoc1([]);
      setselectedDoc2([]);
      if (facility > 0) {
        let resp1 = await stockService.getDoctors();
        let docList = await stockService.getSelectedDoc(facility);
        if (Object.keys(docList).length > 0) {
          let docName1 = resp1.filter(function (e) {
            return e.id === docList?.doc_id;
          });
          let docName2 = resp1.filter(function (e) {
            return e.id === docList?.doc_id_2;
          });
          if (docList?.doc_id && docList?.doc_id > 0) {
            setselectedDoc1([{ id: docName1[0]?.id, name: docName1[0]?.name }]);
          }
          if (docList?.doc_id_2 && docList?.doc_id_2 > 0) {
            setselectedDoc2([{ id: docName2[0]?.id, name: docName2[0]?.name }]);
          }
        } else {
          setselectedDoc1([]);
          setselectedDoc2([]);
        }
        if (resp1) {
          setDoctorList(resp1);
        }
      }
      setLoading(false);
    } catch (e) {
      setselectedDoc1([]);
      setselectedDoc2([]);
      const { hide } = cogoToast.error(
        "Error retrieving Master Drugs List. Please contact administrator...",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }
  const getDrugsList = async (e) => {
    if (e.key === "Enter") {
      let drugName = e.currentTarget.value;
      if (!selectedParent) {
        const { hide } = cogoToast.error("Please Select Parent", {
          hideAfter: 15,
          onClick: () => { hide(); },
        });
      } else if (drugName !== "") {
        try {
          setLoading(true);
          let resp = await stockService.getDrugList(drugName);
          if (resp.length > 0) {
            setEditUserOpen(true);
            dispatch1(updateData(resp));
          } else {
            const { hide } = cogoToast.error("No Records Found!", {
              hideAfter: 15,
              onClick: () => { hide(); },
            });
          }
          setLoading(false);
        } catch (e) {
          const { hide } = cogoToast.error(
            "Error while getting drugs. Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => { hide(); },
            }
          );
        }
      }
    }
  };
  async function dwnloadReport() {
    const doc = new jsPDF("", "", "a3");
    doc.setFont("helvetica");
    doc.setFontSize(9);
    setLoading(true);
    let result = await stockService.getMasterDrugList(
      selectedParent,
      selectedFac
    );
    let resp = result.drugs.sort((a, b) =>
      a.drg_name.localeCompare(b.drg_name)
    );
    setLoading(false);
    let col = ["Drug", "Pack", "Limit", "Last Order Date"];
    let rows = [];
    doc.setFontSize(12);
    doc.setFont("helvetica");
    doc.setFontSize(8);
    let top = 35;
    resp.forEach((ele, i) => {
      let strngth = ele.strength ? "-" + ele.strength : "";
      let dosId = ele.dos_id ? "-" + ele.dos_id : "";
      let temp = [
        ele.drg_name + strngth + dosId,
        ele.pack || "",
        ele.qty_limit || "",
        ele.last_order_date || "",
      ];
      top = top + 5;
      rows.push(temp);
    });
    doc.autoTable(col, rows, { startY: 5 }, "left");
    doc.save("StocksList.pdf");
  }
  useEffect(() => {
    getParents();
    getCategories();
  }, []);

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-11/12 sm:w-4/5 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">FL STOCK ORDERS </span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="stocks">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Parent
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="parent"
                aria-label="Select Parent"
                ref={register({
                  required: "You must select Parent",
                })}
                id="parent"
                onChange={(e) => {
                  getFacilities(e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="" className="text-placeholdercolor ">
                  Select Parent
                </option>
                {parentsList
                  ? parentsList.map((parent, i) => {
                      return (
                        <option key={i} value={parent}>
                          {parent}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Facility
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="facility"
                aria-label="Select Facility"
                ref={register({
                  required: false,
                })}
                onChange={(e) => {
                  getExistingDrugs(selectedParent, e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 text-sm font-normal w-full text-fogotpwsd_login"
              >
                <option value="0">Select Facility</option>
                {facList
                  ? facList.map((facility, i) => {
                      return (
                        <option key={i} value={facility.id}>
                          {facility.name}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Doctor
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <Multiselect
                name="doctor1"
                displayValue="name"
                selectedValues={selectedDoc1}
                options={doctorList}
                ref={multiselectRef}
                onSelect={(e) => {
                  assignDoctor(true, "doc1");
                }}
                onRemove={(e) => {
                  assignDoctor(false, "doc1");
                }}
                selectionLimit={1}
                className="text-fogotpwsd_login"
              />
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Provider
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <Multiselect
                name="doctor2"
                displayValue="name"
                options={doctorList}
                selectedValues={selectedDoc2}
                ref={multiselectRef1}
                onSelect={(e) => {
                  assignDoctor(true, "doc2");
                }}
                onRemove={(e) => {
                  assignDoctor(false, "doc2");
                }}
                selectionLimit={1}
              />
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Drug
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                type="Search Drug"
                onKeyDown={getDrugsList}
                placeholder=" Search"
                className="border focus:outline-none h-11 rounded pl-2 text-sm font-normal w-full "
              />
            </li>
          </ul>
        </div>
      </div>
      <div
        className={`bg-white w-11/12 sm:w-4/5 mx-auto mt-2 mb-4 ${
          showDrugList ? "show" : "hidden"
        }`}
      >
        <div className="pb-5 text-xs">
          <div className="tableHeader flex clearboth  pt-2 pl-3">
            <div className="w-full  text-right">
              <span className="relative">
                <input
                  type="search"
                  defaultValue={tableProps.searchText}
                  onChange={(event) => {
                    dispatch(search(event.currentTarget.value));
                  }}
                  placeholder=" Search"
                  className="border rounded w-5/12 mb-2 h-8 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
                />
                <img
                  src="/img/search-2.svg"
                  alt=""
                  className="absolute w-4 h-4  right-5  bottom-4"
                ></img>
              </span>
              <span className="mr-3">
                <input
                  type="button"
                  onClick={() => {
                    dwnloadReport();
                  }}
                  value="Download"
                  className="text-white w-full sm:w-auto h-8 px-6 
                bg-header_bg rounded text-xs font-medium capitalize 
                focus:outline-none float-right inline-block mr-4"
                />
              </span>
            </div>
          </div>
          <div className="p-4 text-xs gridList overflow-x-auto">
            <Table
              {...tableProps}
              childComponents={{
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "drg_name":
                        return <CustomCell2 {...props} />;
                      case "description":
                        return <CustomCellDescription {...props} />;
                      case "qty_limit":
                        return <CustomCellQnty {...props} />;
                      case "category":
                        return <CustomCellCategory {...props} />;
                      case "parent":
                        return <CustomCell5 {...props} />;
                      case "Actions":
                        return <CustomCell {...props} />;
                    }
                  },
                },
              }}
              dispatch={dispatch}
            />
          </div>
        </div>
      </div>
      <Modal open={deleteOpen} onClose={onDeleteCloseModal} center>
        <div className="pt-10 px-8 pb-4">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            Confirm Delete
          </h3>
          <p className="text-sm text-gray-600 text-center mt-2">
            Are you sure you want to remove this drug from the facility?
          </p>
          <div className="flex justify-center">
            <button
              onClick={confirmDeleteDrug}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Delete
            </button>
            <button
              onClick={onDeleteCloseModal}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={edituserOpen}
        closeOnEsc={false}
        onClose={onCloseUserModal}
        closeOnOverlayClick={false}
        showCloseIcon={true}
        classNames={{
          modal: "customModal drugSearchModal",
        }}
      >
        <form>
          <div className="p-2 text-xs usersList gridList overflow-x-auto">
            <Table
              {...tableProps1}
              childComponents={{
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "drg_name":
                        return <CustomCell2 {...props} />;
                      case "vendor_item":
                        return <CustomVendorItemCell {...props} />;
                      case "ndc":
                        return <CustomNdcCell {...props} />;
                      case "Actions":
                        return <CustomCell1 {...props} />;
                    }
                  },
                },
              }}
              dispatch={dispatch1}
            />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(FLStockOrderForm)
);